import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import React from 'react';

export type PageTitleProps = {
  children: React.ReactNode;
};

const PageTitle = ({ children }: PageTitleProps) => {
  const isSm = useMediaQuery<Theme>(theme => theme.breakpoints.down('sm'));

  return (
    <Typography
      id="skip-to-content"
      variant="h1"
      color="primary"
      gutterBottom
      align={isSm ? 'center' : 'left'}
    >
      {children}
    </Typography>
  );
};

export default PageTitle;
